<template>
    <div class="account-record-detail">
        <el-card class="page-card">
            <template #header>
                <div class="card-header">账户记录详情</div>
            </template>

            <div class="card-body">
                <el-row type="flex" justify="space-between" align="middle" class="toolbar">
                    <el-col>
                        <el-button v-if="showBackButton" type="primary" icon="el-icon-arrow-left"
                            @click="goBack">返回</el-button>
                        <el-button type="primary" icon="el-icon-refresh" @click="fetchData">刷新</el-button>
                    </el-col>
                    <el-col>
                        <el-select v-model="filters.type" placeholder="交易类型" clearable
                            style="width:120px; margin-right:8px">
                            <el-option label="充值" :value="1"></el-option>
                            <el-option label="消费" :value="2"></el-option>
                            <el-option label="退款" :value="3"></el-option>
                            <el-option label="调整" :value="4"></el-option>
                        </el-select>
                        <el-date-picker v-model="filters.dateRange" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                            style="width:240px; margin-right:8px"></el-date-picker>
                        <el-input size="small" placeholder="备注关键字" v-model="filters.remark"
                            style="width:180px; margin-right:8px" clearable>
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="handleSearch"></i>
                        </el-input>
                        <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
                        <el-button size="small" @click="handleReset">重置</el-button>
                    </el-col>
                </el-row>

                <el-table :data="list" stripe border style="width: 100%; margin-top: 12px" :loading="loading">
                    <el-table-column prop="company_id" label="公司ID" width="100" align="center" header-align="center" />
                    <el-table-column prop="company_name" label="公司名称" align="center" header-align="center" />
                    <el-table-column prop="order_amount" label="订单金额" width="100" align="center"
                        header-align="center" />
                    <el-table-column prop="service_amount" label="手续费" width="100" align="center"
                        header-align="center" />
                    <el-table-column prop="service_fee_type" label="手续费规则" width="120" align="center"
                        header-align="center" />
                    <el-table-column prop="service_fee_type_content" label="规则内容" align="center" header-align="center"
                        show-overflow-tooltip />
                    <el-table-column prop="type" label="交易类型" align="center" header-align="center">
                        <template v-slot="{ row }">
                            <el-tag size="small" :type="getTypeTagType(row.type)">{{ getTypeText(row.type) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="交易金额" width="100" align="center" header-align="center" />
                    <el-table-column prop="direction" label="出/入账" width="100" align="center" header-align="center">
                        <template v-slot="{ row }">
                            <el-tag size="small" :type="row.direction === 1 ? 'success' : 'danger'">
                                {{ row.direction === 1 ? '入账' : '出账' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="balance_before" label="操作前余额" width="120" align="center"
                        header-align="center" />
                    <el-table-column prop="balance_after" label="操作后余额" width="120" align="center"
                        header-align="center" />
                    <el-table-column prop="operator_name" label="操作人" align="center" width="100"
                        header-align="center" />
                    <el-table-column prop="voucher" label="凭证" align="center" header-align="center">
                        <template v-slot="{ row }">
                            <el-button v-if="row.voucher" type="text" size="small"
                                @click="handleVoucher(row.voucher)">查看</el-button>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" align="center" header-align="center"
                        show-overflow-tooltip />
                    <el-table-column prop="created_at" label="创建时间" width="180" align="center" header-align="center" />
                </el-table>

                <div class="pagination-wrap">
                    <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total"
                        :page-sizes="[10, 15, 20, 50]" :page-size.sync="pager.pageSize" :current-page.sync="pager.page"
                        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>
            </div>
        </el-card>

        <!-- 凭证查看对话框 -->
        <el-dialog :visible.sync="voucherDialog" title="凭证查看" width="800px" :close-on-click-modal="false">
            <div class="voucher-container">
                <img v-if="currentVoucher" :src="currentVoucher" alt="凭证图片" style="max-width: 100%; max-height: 600px">
                <div v-else>暂无凭证图片</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="voucherDialog = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { accountRecord } from '@/api/api'

export default {
    name: 'AccountRecordDetail',
    data() {
        return {
            loading: false,
            list: [],
            total: 0,
            pager: { page: 1, pageSize: 15 },
            filters: {
                company_account_id: '',
                type: '',
                dateRange: [],
                remark: ''
            },
            // 是否显示返回按钮
            showBackButton: false,
            // 凭证查看
            voucherDialog: false,
            currentVoucher: ''
        }
    },

    mounted() {
        // 从路由参数中获取公司账户ID
        const companyAccountId = this.$route.query.company_account_id
        if (companyAccountId) {
            this.filters.company_account_id = companyAccountId
            // 有参数时显示返回按钮（从账户管理页面跳转过来）
            this.showBackButton = true
        }
        // 无论是否有company_account_id参数，都请求接口
        this.fetchData()
    },
    methods: {
        async fetchData() {
            this.loading = true
            try {
                const params = {
                    page: this.pager.page,
                    per_page: this.pager.pageSize,
                    company_account_id: this.filters.company_account_id || '',
                    type: this.filters.type || undefined,
                    start_date: this.filters.dateRange && this.filters.dateRange.length > 0 ? this.filters.dateRange[0] : undefined,
                    end_date: this.filters.dateRange && this.filters.dateRange.length > 1 ? this.filters.dateRange[1] : undefined,
                    remark: this.filters.remark || undefined
                }
                const res = await accountRecord(params)

                this.list = res.data.data || []
                this.total = res.data.total || res.data.count || 0
            } catch (err) {
                console.error('accountRecord error', err)
                this.$message.error(err.message || '获取账户记录失败')
                this.list = []
                this.total = 0
            } finally {
                this.loading = false
            }
        },

        getTypeText(type) {
            const typeMap = {
                1: '充值',
                2: '消费',
                3: '退款',
                4: '调整'
            }
            return typeMap[type] || '未知'
        },

        getTypeTagType(type) {
            const typeColorMap = {
                1: 'success',
                2: 'danger',
                3: 'warning',
                4: 'info'
            }
            return typeColorMap[type] || 'default'
        },

        handleSizeChange(size) {
            this.pager.pageSize = size
            this.pager.page = 1
            this.fetchData()
        },

        handleCurrentChange(page) {
            this.pager.page = page
            this.fetchData()
        },

        handleSearch() {
            this.pager.page = 1
            this.fetchData()
        },

        handleReset() {
            this.filters = {
                company_account_id: this.filters.company_account_id,
                type: '',
                dateRange: [],
                remark: ''
            }
            this.pager.page = 1
            this.fetchData()
        },

        goBack() {
            this.$router.push('/account')
        },

        handleVoucher(voucher) {
            this.currentVoucher = voucher
            this.voucherDialog = true
        }
    }
}
</script>

<style scoped>
.page-card {
    margin: 20px 12px;
    height: calc(100vh - 64px - 48px);
    overflow-y: auto;
}

.card-header {
    font-weight: 700;
    color: #409EFF;
}

.card-body {
    padding: 12px;
}

.toolbar {
    margin-bottom: 6px;
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}

.voucher-container {
    text-align: center;
    padding: 20px 0;
}
</style>